/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { HotelTariffCard } from '@lt/components';
import { useTranslation } from '@lt/localization';
import classnames from 'classnames';

import { dynamic } from 'src/helpers/dynamic';
import type { HotelRatesResultsProps } from '../Searcher/types';
import styles from './hotelRatesResults.module.css';

const AboutRoomPopup = dynamic(
  () =>
    import(
      /* webpackChunkName: "AboutRoomPopup" */ 'src/routes/Hotel/containers/AboutRoomPopup'
    ),
);

export const HotelRatesResults = ({
  items,
  searchedNights,
  onOfferClicked,
  onClickOpenFilters,
  onLeaveNotFullOffersSpan,
  onClickGallery,
  hotelFacilities,
  isWhiteLabel,
  activateCashbackForPartner,
  tourists,
  isSetDefaultFilters,
  isMobile,
  labelColor,
  textColor,
  cashbackIconWebp,
  cashbackIconPng,
  cashbackTooltipText,
  cashbackLabel,
  ...rest
}: HotelRatesResultsProps) => {
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={styles.container} {...rest}>
      {isSetDefaultFilters ? (
        <div
          className={classnames(styles.notFullOffers, {
            [styles.notFullOffersDesktop]: !isMobile,
            [styles.notFullOffersMobile]: isMobile,
          })}
        >
          {t('hotel.ratesResults.notFullOffersАccommodation_hotel')}
          {isMobile ? <br /> : ' '}
          {t('hotel.ratesResults.notFullOffersFilters')}
          <span
            className={classnames(styles.span, {
              [styles.spanDesktop]: !isMobile,
            })}
            onClick={onClickOpenFilters}
            onMouseLeave={onLeaveNotFullOffersSpan}
          >
            {t('hotel.ratesResults.notFullOffersButton')}
          </span>
        </div>
      ) : null}
      {items.map((item) => (
        <div className={styles.itemWrapper} key={item.ID}>
          <HotelTariffCard
            room={item.room}
            area={item.room.area}
            mealTypes={item.meal_types}
            offers={item.offers}
            labels={item.labels}
            nights={searchedNights}
            hotelFacilities={hotelFacilities}
            onOfferClicked={onOfferClicked}
            bonusCount={activateCashbackForPartner ? item.bonus_count : null}
            isWhiteLabel={isWhiteLabel}
            tourists={tourists}
            isMobile={isMobile}
            onClickGallery={onClickGallery}
            cashbackTooltipText={cashbackTooltipText}
            labelColor={labelColor}
            textColor={textColor}
            cashbackIconWebp={cashbackIconWebp}
            cashbackIconPng={cashbackIconPng}
            cashbackLabel={cashbackLabel}
          />
        </div>
      ))}
      <AboutRoomPopup />
    </div>
  );
};
